import { GetPopulationDetailsResponse, KitPopulationClient } from '@app/api2/api';
import * as React from 'react';
import { Container, Header, Label, LabelDetail, List, ListContent, ListHeader, ListItem, Message, Segment } from 'semantic-ui-react';
import { buildUrl, AppRoutes } from '../AppRoutes';
import { areYouSure, areYouSure2 } from '../AreYouSure';
import { PageHeader } from '@common/PageHeader';
import { downloadBlob, insertComponentsIntoText, toSci } from '@common/Utils';
import { useTranslation2 } from '../Contexts/TranslationContext2';
import { useQuery } from '@tanstack/react-query';
import BPLoading from '../Common/BPLoading';
import { delay } from '@/lib/utils';
import { BPContainer } from '@/components/bp/bpcontainer';

interface IPopulationDetailsProps {
  populationId: number;
}

export const PopulationDetails: React.FunctionComponent<IPopulationDetailsProps> = (props) => {
  const { translations: t } = useTranslation2();
  const client = new KitPopulationClient()

  // const [population, setPopulation] = React.useState<GetPopulationDetailsResponse>()

  const populationQuery = useQuery({
    queryKey: ['populationDetails', props.populationId],
    queryFn: async () => {
      await delay(2000); // artificial delay for demo purposes
      let res = await client.getPopulationDetails(props.populationId)
      return res;
    },
  })

  if (populationQuery.isLoading) {
    return <BPLoading />;
  }

  const population = populationQuery.data;

  const downloadPopulation = async () => {

    let res = await client.download(props.populationId)
    downloadBlob({ data: res.data, fileName: res.fileName });

  };

  const deletePopulation = async () => {
    areYouSure2({
      message: t.populationView.deleteConfirm,
      title: t.common.confirmDelete,
      action: () => {
        client.delete(props.populationId);
      }
    })
  };

  return <>
    <BPContainer>
      <PageHeader
        header={insertComponentsIntoText(t.populationView.detail, {
          '{populationName}': population?.name,
        })}
        buttons={[
          { label: t.common.download, action: async () => await downloadPopulation() },
          { label: t.common.edit, to: buildUrl(AppRoutes.PopulationEdit, { populationId: props.populationId }) },
          { label: population?.canDelete ? t.common.delete : t.common.enable, negative: population?.canDelete, action: async () => population.canDelete ? await deletePopulation() : await client.restore(props.populationId) },
        ]}
      ></PageHeader>

      {population?.weights?.length > 0 && <Segment basic clearing compact attached={'bottom'}>
        <List horizontal>
          <ListItem>
            <ListContent>
              <ListHeader>
                {t.populationView.sourcePopulations}:
              </ListHeader>
            </ListContent>
          </ListItem>
          {/* <div role="listitem" className="item"><div className="content"><div className="header">Source Populations: </div></div></div> */}

          {population?.weights.map(a => (
            <ListItem key={a.populationName}>
              <ListContent verticalAlign='middle'>
                <span>{a.populationName}</span>&nbsp;&nbsp;
                <span style={{ fontSize: '1.3em', fontWeight: 'bold' }}>{a.weight}</span>
                {/* <Label basic size='large'>{a.populationName}<LabelDetail><span style={{fontSize: '1.3em' }}>{a.weight}</span></LabelDetail></Label> */}
              </ListContent>
            </ListItem>

            // <div key={a.populationName} role="listitem" className="item"><div className="content"></div></div>
          ))

          }
        </List>
      </Segment>
      }
      <div className="widetable">
        <table className="ui compact celled striped table ">
          <thead>
            <tr>
              <th></th>
              {population?.systemFrequencies.map(a => (
                <th key={`h${a.system}`}>{a.system}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {population?.allAlleles.map(a => (
              <tr key={`a${a}`}>
                <td>{a}</td>
                {
                  population?.systemFrequencies?.map(s => { return <td key={`h${s.system}a${a}`}>{s.alleleFrequencies.find(af => af.allele == a)?.frequency.toFixed(5)}</td> })
                }
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </BPContainer>
  </>;
};
